export default {
	REGISTRATION: 1,
	PAYMENT: 2,
	DONATION: 3,
	LOYALTY: 4,
	VIDEO_REQUEST: 5,
	CONSULTATION: 6,
	LEAD: 7,
	SUBSCRIPTION: 8,
	PERSONAL: 9,
	DOWNLOAD: 10,
};
